import { useEffect, useRef } from 'react'

import { useProgress } from 'hooks/useProgress'
import { Text } from 'blaze-ui/Text/Text'
import { LoadingEllipses } from 'components/Wizards/Wizard/Form/SectionHeader'

export const LoadingText = () => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  const {
    start: startFour,
    isRunning: isRunningFour,
    progress: progressFour,
  } = useProgress({ linearProgress: true, speed: 35 })
  const {
    start: startThree,
    isRunning: isRunningThree,
    progress: progressThree,
  } = useProgress({ linearProgress: true, speed: 35, immediateComplete: true, onDone: startFour })
  const {
    start: startTwo,
    isRunning: isRunningTwo,
    progress: progressTwo,
  } = useProgress({ linearProgress: true, speed: 35, immediateComplete: true, onDone: startThree })
  const {
    start: startOne,
    isRunning: isRunningOne,
    progress: progressOne,
  } = useProgress({ linearProgress: true, speed: 75, immediateComplete: true, onDone: startTwo })

  if (!isRunningOne && progressOne === 0) {
    startOne()
  }

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
        timeoutRef.current = null
      }
    }
  }, [])

  const progresses = [
    {
      title: 'Blaze is thinking',
      isRunning: isRunningOne,
      percentComplete: progressOne,
    },
    {
      title: 'Analyzing your website',
      isRunning: isRunningTwo,
      percentComplete: progressTwo,
    },
    {
      title: 'Locating business',
      isRunning: isRunningThree,
      percentComplete: progressThree,
    },
    {
      title: 'Looking for competitors',
      isRunning: isRunningFour,
      percentComplete: progressFour,
    },
  ]

  return (
    <>
      {progresses.map((progress) => {
        if (!progress.isRunning) return null

        return (
          <Text color="var(--dark-40)" key={progress.title}>
            {progress.title}
            <LoadingEllipses />
          </Text>
        )
      })}
    </>
  )
}
